import React from "react";
import { Row, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import DownloadImage from "../../../assets/images/download.svg";
import { formatDate } from "../../../constant/DateFormat";

const PolicyItemMobile = ({ item }: { item: any }) => {
  const history = useHistory();
  const handleClick = () => {
    history.push({
      pathname: `/policy-details/${item.policyId}`,
      state: {data: item}
    });
    //history.push(`/policy-details/${item.id}`);
  };

  return (
    <>
      <Row className='bgwhite p-3 mb-3' onClick={handleClick}>
        <Col xs={11} style={styles.date} className='px-0'>
          Effective Date{' '}
          {item?.effectiveDate ? formatDate('' + item?.effectiveDate) : '-'}
        </Col>
        <Col xs={1} className='px-0'>
          <a href={item.downloadLink} rel='noopener noreferrer' target='_blank'>
            <img src={DownloadImage} />
          </a>
        </Col>
        <Col xs={12} style={styles.name} className='px-0'>
          {item?.policyName ? item?.policyName : '-'}
        </Col>
        <Col xs={12} style={styles.data} className='px-0'>
          {item?.objectives ? item?.objectives : '-'}
        </Col>
      </Row>
    </>
  );
};

const styles: any = {
    date: {
        fontFamily: "Saira",
        fontSize: "12px",
        fontWeight: "400",
        color: "#242424",
      },
      name: {
        fontFamily: "Saira",
        fontSize: "20px",
        fontWeight: "500",
        color: "black",
      },
    data: {
        fontFamily: "Saira",
        fontSize: "12px",
        fontWeight: "500",
        marginTop: "20px",
    },
};

export default PolicyItemMobile;
